'use client';

import { AppBar, Toolbar, Button, Box } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';

export default function Header() {
  return (
    <AppBar position="static" sx={{ bgcolor: 'rgba(36,61,99,0.9)' }}>
      <Toolbar>
        <Link href="/" style={{ display: 'flex', alignItems: 'center' }}>
          <Image
            src="/assets/images/AutomateAnalyzeInnovate.png"
            alt="Automate Analyze Innovate logo"
            width={40}
            height={40}
            priority
          />
        </Link>
        <Box sx={{ flexGrow: 1 }} />
         <Button
          color="inherit"
          component={Link}
          href="/blog"
          sx={{ textTransform: 'none' }}
        >
          Blog
        </Button>
        <Button
          color="inherit"
          component={Link}
          href="/portfolio"
          sx={{ textTransform: 'none' }}
        >
          Portfolio
        </Button>
        <Button
          color="inherit"
          component={Link}
          href="/contact"
          sx={{ textTransform: 'none' }}
        >
          Contact
        </Button>
      </Toolbar>
    </AppBar>
  );
}
